export function formatCurrency(cents: number): string {
  const formatted = (Math.abs(cents) / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return cents < 0 ? `-$${formatted}` : `$${formatted}`
}

/**
 * Convert a user-entered dollar amount to integer cents.
 * The only sanctioned float→cents boundary on the client — inputs are
 * typed in dollars, everything downstream stores and computes in cents.
 */
export function dollarsToCents(dollars: number): number {
  return Math.round(dollars * 100)
}

/**
 * Guest-facing sticker format — used on list cards, map pins, vehicle
 * detail, booking intro.
 *
 *   formatPrice(4500)                           → "$45"
 *   formatPrice(4500, { unit: 'day' })          → "$45/día"
 *   formatPrice(4567, { unit: 'hour' })         → "$45.67/hr"
 *   formatPrice(4500, { unit: 'day', locale: 'en' }) → "$45/day"
 *
 * Cents are omitted when zero so "$45" doesn't render as "$45.00" in
 * tight card layouts. Checkout and invoices use `formatCurrency` for
 * the "$X,XXX.XX" form where exact decimals matter.
 *
 * Change the glyph, order, or locale handling here to reskin every
 * sticker across the app in one edit.
 */
export function formatPrice(
  cents: number,
  opts?: { unit?: 'day' | 'hour'; locale?: 'es' | 'en' },
): string {
  const dollars = cents / 100
  const body = dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2)
  if (!opts?.unit) return `$${body}`
  const suffix =
    opts.locale === 'en'
      ? opts.unit === 'hour'
        ? '/hr'
        : '/day'
      : opts.unit === 'hour'
        ? '/hr'
        : '/día'
  return `$${body}${suffix}`
}
